module.exports = __webpack_public_path__ + "static/media/workPvcCeilings6.4e043c88.jpg";